/**
 * @generated SignedSource<<472b790b3dca6f2e705a5caf3b3efe0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFormTPayload",
        "kind": "LinkedField",
        "name": "updateFormTByFormId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormT",
            "kind": "LinkedField",
            "name": "formT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFormTPayload",
        "kind": "LinkedField",
        "name": "updateFormTByFormId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormT",
            "kind": "LinkedField",
            "name": "formT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "99eda81155a7e9e22324c220a7d9fe58",
    "id": null,
    "metadata": {},
    "name": "FormUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation FormUpdateMutation(\n  $input: UpdateFormTByFormIdInput!\n) {\n  updateFormTByFormId(input: $input) {\n    formT {\n      formId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "4d5ccf16ff7e269704005c3213a64afc";

module.exports = node;
